import Vue from 'vue';

import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/stock/',
        name: 'Index',
        component: () => import('../views/index/index.vue'),
      },
      {
        path: '/fund/',
        name: 'Index2',
        component: () => import('../views/index2/index2.vue'),
      },
      {
        path: '/gushou/',
        name: 'Index3',
        component: () => import('../views/index3/index3.vue')
      },
      {
        path: '/indexValuation',
        name: 'IndexValuation',
        component: () => import('../views/IndexValuation/IndexValuation.vue')
      },
      {
        path: '/plateTheme',
        name: 'PlateTheme',
        component: () => import('../views/PlateTheme/PlateTheme.vue')
      }, 
      {
        path: '/smartStock',
        name: 'SmartStock',
        component: () => import('../views/SmartStock/SmartStock.vue')
      }, 
      {
        path: '/smartFund',
        name: 'SmartFund',
        component: () => import('../views/SmartFund/SmartFund.vue')
      }, 
      {
        path: '/informationCommunity',
        name: 'InformationCommunity',
        component: () => import('../views/InformationCommunity/InformationCommunity.vue')
      }, 
      {
        path: '/zuoye',
        name: 'CopyOperation',
        component: () => import('../views/CopyOperation/CopyOperation.vue')
      }, 
      {
        path: '/stock/:codes',
        name: 'shares_Info',
        component: () => import('../views/shares_Info/shares_Info.vue')
      },
      {
        path: '/zhishu/:codes',
        name: 'index_Info',
        component: () => import('../views/index_Info/index_Info.vue')
      },
      {
        path: '/fund/:codes',
        name: 'fund_Info',
        component: () => import('../views/fund_Info/fund_Info.vue')
      },
      {
        path: '/income_Info',
        name: 'income_Info',
        component: () => import('../views/income_Info/income_Info.vue')
      },
      {
        path:'*',
        redirect:'/stock/'
      }
    ]
  }
]

const router = new VueRouter({
  mode:'history',        //默认位hash
  routes
})
export default router
